import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AutoErrorComponent } from "./components/auto-error/auto-error.component";
import { ControlErrorsDirective } from "./directives/control-errors/control-errors.directive";
import { ControlErrorContainerDirective } from "./directives/control-error-container/control-error-container.directive";
import { FormSubmitDirective } from "./directives/form-submit/form-submit.directive";
import { ReactiveFormsModule } from "@angular/forms";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';


@NgModule({
    declarations: [
        AutoErrorComponent,
        ControlErrorsDirective,
        ControlErrorContainerDirective,
        FormSubmitDirective
    ],
    imports: [
        CommonModule //,
        //FormGroup, FormControl, FormBuilder, Validators
    ],
    exports: [
        AutoErrorComponent,
        ControlErrorsDirective,
        ControlErrorContainerDirective,
        FormSubmitDirective,
        ReactiveFormsModule
    ]
})
export class ValidationsModule {}
